import { saveAs } from "file-saver";

// Extracts a filename from a URL if the name isn't provided
const getFileNameFromUrl = (url) => {
  try {
    const urlObj = new URL(url);
    return decodeURIComponent(urlObj.pathname.split("/").pop()) || "downloaded_file";
  } catch {
    return "downloaded_file";
  }
};

// Helper function to download a single file
const downloadFile = async (url, fileName, sasToken) => {
  const fileUrlWithSas = `${url}?${sasToken}`;

  try {
    const response = await fetch(fileUrlWithSas);
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const blob = await response.blob();
    saveAs(blob, fileName);
    console.log(`✅ Successfully downloaded: ${fileName}`);
  } catch (error) {
    console.error(`❌ Failed to download ${fileName}: ${error.message}`);
  }
};

// Recursively extract files from a nested object
const extractFiles = (data) => {
  console.log("data",data);
  const documents = [];
  
  const documentPaths = [
    { path: data?.workExperience?.previousEmploymentHistory, fileType: "Previous Employment History" },
    { path: data?.workExperience?.schoolUniversityHistory, fileType: "School/University History" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.additionalCertificate, fileType: "Additional Certificate" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.bankDetails, fileType: "Bank Details" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.headAndShoulderPhoto, fileType: "Head and Shoulder Photo" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.idOrBiometricBack, fileType: "ID Or Biometric Back" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.idOrBiometricFront, fileType: "ID Or Biometric Front" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.passportOrBirthCertificate, fileType: "Passport Or Birth Certificate" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.proofOfAddress, fileType: "Proof of Address" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.proofOfNationalInsurance, fileType: "Proof of National Insurance" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.universityEnrollmentLetter, fileType: "University Enrollment Letter" },
    { path: data?.complianceAndOtherDocuments?.uploadedDocuments?.universityTermVacationDate, fileType: "University Term Vacation Date" }
  ];

  documentPaths.forEach(({ path, fileType }) => {
    if (path?.url) {
      documents.push({
        url: path.url,
        name: path.name || getFileNameFromUrl(path.url),
        fileType,
      });
    }
  });

  return documents;
};

// **Updated** function to download files **synchronously**
export const downloadFiles = async (data, sasToken) => {
  const filesToDownload = extractFiles(data);

  if (filesToDownload.length === 0) {
    console.warn("No valid files found for download.");
    return;
  }

  console.log(`Starting synchronous download of ${filesToDownload.length} files...`);
  console.log("filesToDownload", filesToDownload);
  for (const { url, name } of filesToDownload) {

    await downloadFile(url, name, sasToken); // Wait for each file to complete before proceeding
  }

  console.log("✅ All files downloaded successfully!");
};
